import * as TabButton from './TabButton.css';

export default {
	TabButton
};
